import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NavBar from './Components/NavBar/NavBar';
import MainPage from './Pages/MainPage';
import About from './Pages/About';
import Contact from './Pages/Contact';
import Accommodation from './Pages/Accommodation';
import Menu from './Pages/Menu';
import Agenda from './Pages/Agenda';
import FAQs from './Pages/FAQs';
import RSVP from './Pages/RSVP';
import { useStore } from './Stores/store';
import LandingPage from './Pages/LandingPage';
import Thanks from './Pages/Thanks';
import { observer } from 'mobx-react-lite';
import { DayGuestRoutes, EveningGuestRoutes, ProtectedRoutes } from './Components/ProtectedRoutes';
import Footer from './Components/Footer';
import { ToastContainer } from 'react-toastify';
import Gifting from './Pages/Gifting';

const App = observer(() => {
  const { generalStore } = useStore();
  const { showFooterAndNav: showNav } = generalStore;

  return (
    <BrowserRouter>
          {
            showNav && <NavBar />
          }
      <div className="min-h-screen flex-col flex">
          <div className="flex-grow w-9/10 sm:w-4/5 mx-auto">
          <Routes>
            <Route path="/" element={<LandingPage useHelm />} />
              <Route element={<ProtectedRoutes />} >
                <Route element={<EveningGuestRoutes />}>
                  <Route path="/app" element={<MainPage />} />
                  <Route path="/app/about" element={<About useHelm/>} />
                  <Route path="/app/contact" element={<Contact useHelm/>} />
                  <Route path="/app/agenda" element={<Agenda useHelm/>} />
                  <Route path="/app/accommodation" element={<Accommodation useHelm/>} />  
                  <Route path='/app/faqs' element={<FAQs useHelm/>} />
                  <Route path="/app/rsvp" element={<RSVP />} />
                  <Route path="/app/rsvp/thanks" element={<Thanks />} />
                  <Route path="/app/gifting" element={<Gifting useHelm />} />
                  <Route element={<DayGuestRoutes />}>
                    <Route path='/app/menu' element={<Menu useHelm/>} />
                  </Route>
                </Route>
            </Route>
          </Routes>
          </div>
        <ToastContainer />
        <Footer />
        </div>
    </BrowserRouter>
  );
});

export default App;
